module.exports = __webpack_public_path__ + "static/slide1right-386151e5cc43c2a5fc4b2d7f39be9532.webp";